<div class="splashContainer">
  <div class="splashIndicator">
    <div class="a-activity-indicator" aria-live="off">
      <div class="a-activity-indicator__top-box"></div>
      <div class="a-activity-indicator__bottom-box"></div>
    </div>
  </div>
</div>
